import React from 'react'
import { Text } from "@chakra-ui/core";

const LargeText = props => <Text {...props} fontSize='xl' />

export default LargeText